import { isNumberBlank } from './is-number-blank';

export const formatNumberWithFixedPrecision = (x, min = 0) => {
  const n = Number(x);
  return isNumberBlank(x) ? '-' : n.toFixed(min);
};
